module.exports = __webpack_public_path__ + "img/qq.359edf2d.png";